import React, { useReducer, useContext } from "react"
import { Action } from "../models/Action";
import PolicyManagementApi from "../api/policymanagement.api";
import { INSURANCE_CONTEXT_ACTIONS } from "./InsuracePurchaseContext";
import policymanagementApi from "../api/policymanagement.api";
import { useParams } from "react-router-dom";
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import { awaitWithLoading, isUK } from "../services/utils";
import { PolicyManagementContextStore, ACTIONS as PolicyManagementContextActions } from './PolicyManagementContext';
import { ActiveInsuranceModel } from "../models/insurance-models/ActiveInsuranceModel";
import policymanagementCoiApi from "../api/policymanagement.coi.api";
import { COI } from "../models/coi/coi.model";

export const ACTIONS = {
    LOAD_COIS: 'LOAD_COIS',
    EDIT_COI: 'EDIT_COI',
}

const defaultState = {
    dispatch: (action: Action) => {},
    cois: [],
}

const reducer = (state, action: Action) => {
    switch (action.type) {
        case ACTIONS.EDIT_COI:
            return {...state, cois: state.cois.map(coi => coi.certificateId === action.data.certificateId ? action.data : coi)}
        case ACTIONS.LOAD_COIS:
            return {...state, cois: action.data.cois}
      default: 
        return state
    }
};


export const PolicyCOIExtensionContextStore = React.createContext(defaultState)

const PolicyCOIExtensionContext = (props) => {
    const [state, dispatch] = useReducer(reducer, defaultState)
    
    const loadPolicyCOIs = async (insuranceId) => {

        let res = await policymanagementCoiApi.getPolicyCOIs(insuranceId)
        if(res.ok) {
            dispatch(new Action(ACTIONS.LOAD_COIS, {cois: res.parsedData}))
            return res.parsedData
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    return (<PolicyCOIExtensionContextStore.Provider value={{ ...state, dispatch, loadPolicyCOIs }}>
            {props.children}
        </PolicyCOIExtensionContextStore.Provider>)   
}

export default PolicyCOIExtensionContext



